import type { RenderComponentProps } from "../../../shared/types";

import * as React from "react";

import { SharedShopifyLiquid } from "../SharedShopifyLiquid";

function FeraMediaGalleryWidget(props: RenderComponentProps) {
  const { componentAttributes, component } = props;
  const liquidSource = '<div data-fera-container="store_customer_media"></div>';

  return (
    <SharedShopifyLiquid
      liquidSource={liquidSource}
      componentId={component.id}
      componentAttributes={componentAttributes}
      placeholderType="gallery"
      title="Fera Media Gallery"
      isLiquidSupported
    />
  );
}

export default FeraMediaGalleryWidget;
